import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Divider, Grid, IconButton, Typography } from '@mui/material'
import { GridArrowDownwardIcon } from '@mui/x-data-grid'
import { t } from 'i18next'
import React, { useRef } from 'react'
import { TComptuedKey } from '../../shared/types/exam.type'
import ParamSection from './ParamSection'
import Slider, { Settings, SwipeDirection } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ArrowRight, ChevronLeft, ChevronRight } from '@mui/icons-material'
import { Link, useNavigate } from 'react-router-dom'
import { routes } from '../../pages/routes'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { useAuth } from '../../hooks/useAuth'

type KeyParamSectionProps = {
    keyParams?: TComptuedKey[],
    restrictedMode?: boolean,
    printable?: boolean,
}



function KeyParamSection({ keyParams, restrictedMode, printable = false }: KeyParamSectionProps) {
    const { auth } = useAuth()


    // Switch title based on user type
    const renderTitle = auth?.type === "POLO" ? t('keyParameters:polo:title') : t('keyParameters:title')

    return (
        <>
            <Accordion defaultExpanded>
                <AccordionSummary
                    expandIcon={<GridArrowDownwardIcon />}
                >
                    <Box width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                        <Typography variant='subtitle2'>{renderTitle}</Typography>
                        {
                            !restrictedMode && <Button component={Link} to={routes.DASHBOARD_ROUTES.MYTRAININGS} target='_blank' onClick={e => e.stopPropagation()} sx={{ mr: 2 }} variant='outlined' color='warning'>{t('settings:editKeyParameters')}</Button>
                        }
                    </Box>
                </AccordionSummary>
                <AccordionDetails className="slider-container" sx={{ overflow: 'hidden', p: 5 }}>
                    <Grid container spacing={4} sx={{ overflow: 'hidden' }}>
                        {keyParams?.map((key, i) => (
                            <React.Fragment key={i}>
                                <Grid sx={{ padding: '0px !important' }} item md={3} sm={printable ? 3 : 6} xs={printable ? 3 : 6}>
                                    <ParamSection printable={printable} length={keyParams.length} index={i + 1} key={key['@id']} param={key}></ParamSection>
                                </Grid>
                            </React.Fragment>
                        ))}

                    </Grid>



                </AccordionDetails>
            </Accordion>
        </>
    )
}

export default KeyParamSection